import { render } from "./CommentsLikes.vue?vue&type=template&id=811691cc&ts=true"
import script from "./CommentsLikes.vue?vue&type=script&lang=ts"
export * from "./CommentsLikes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__